/**
 * Health-check broker — subsystem status + offline simulation control.
 */
import AxiosManager from '@/utils/AxiosManager'
import Constants from '@/helpers/Constants'

export interface HealthComponent {
  key: string
  label: string
  live: number
  simulated_offline: boolean
  effective: number
}

export interface HealthCheckStatus {
  ts: string
  components: HealthComponent[]
  overrides: Record<string, boolean>
  any_offline: boolean
}

export default class HealthCheckBroker {
  private static get ax(): AxiosManager {
    return new AxiosManager(Constants.SERVER_URL)
  }

  public static async getStatus(): Promise<HealthCheckStatus> {
    return await HealthCheckBroker.ax.get('/health_check_status')
  }

  public static async setComponentOffline(
    component: string,
    offline: boolean,
  ): Promise<{ overrides: Record<string, boolean> }> {
    return await HealthCheckBroker.ax.post('/health_check_control', {
      component,
      offline,
    })
  }

  public static async setOverrides(
    overrides: Record<string, boolean>,
  ): Promise<{ overrides: Record<string, boolean> }> {
    return await HealthCheckBroker.ax.post('/health_check_control', {
      overrides,
    })
  }

  public static async clearOverrides(): Promise<{ overrides: Record<string, boolean> }> {
    return await HealthCheckBroker.ax.post('/health_check_control', {
      action: 'clear',
    })
  }
}
